import { FC } from 'react'
import { observer } from 'mobx-react'
import { IPublicCompany } from '@/types'
import { Avatar } from '@/components/atoms/Avatar'
import { getCompanyLogo } from '@/utils'
import { CompanyDetailShareAndReportContent } from '@/components/molecules/CompanyDetailShareAndReportContent'
import styles from './index.module.scss'

type Props = {
  company: IPublicCompany
}

export const CompanyDetailHeaderTitle: FC<Props> = observer(({ company }) => {
  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <Avatar src={getCompanyLogo(company)} alt={company.name} isOutline />
      </div>
      <div className={styles.link}>
        <CompanyDetailShareAndReportContent company={company} />
      </div>
    </div>
  )
})
